export const coverageEndpoints={
    w2coverageStateList:'/service-providers/w2-coverage/states',
    w2GetCitiesByState:'/service-providers/w2-coverage/cities',
    updateW2Coverage:"/service-providers/w2-coverage",
    fuzzyMatchCities:"/service-providers/coverage/map-settings",
    geoapifyPlaces:"https://api.geoapify.com/v2/places"
}